import * as React from 'react';
import Svg, {SvgProps, Circle, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    viewBox={'0 0 20 20'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <Circle cx={10} cy={10} r={9.5} stroke={props.fill || '#fff'} />
    <Path
      fill={props.fill || '#fff'}
      d="M11.797 8.437c.516-.657 1.401-.986 2.657-.986.817 0 1.542.162 2.177.486.634.324.952.936.952 1.835v3.424c0 .237.004.525.013.862.014.256.053.43.117.52a.7.7 0 0 0 .287.227v.287h-2.122c-.06-.15-.1-.292-.123-.424a5.125 5.125 0 0 1-.055-.452c-.27.292-.58.54-.931.746a2.8 2.8 0 0 1-1.425.363c-.675 0-1.234-.192-1.677-.575-.438-.388-.657-.936-.657-1.643 0-.918.354-1.582 1.061-1.993.388-.223.959-.383 1.712-.48l.664-.081c.36-.046.618-.103.774-.171.278-.12.417-.304.417-.555 0-.306-.107-.516-.322-.63-.21-.119-.52-.178-.93-.178-.462 0-.788.114-.98.342-.137.17-.228.398-.274.685H11.25c.041-.653.224-1.189.548-1.609Zm1.452 5.245c.182.15.406.226.67.226.42 0 .806-.123 1.158-.37.356-.247.54-.696.554-1.349v-.726a2.254 2.254 0 0 1-.376.192 3.288 3.288 0 0 1-.514.13l-.438.082c-.41.073-.705.162-.883.267-.301.178-.452.455-.452.829 0 .333.094.573.28.719Z"
    />
    <Path
      fill={props.fill || '#fff'}
      d="M9.284 13.018H5.566l-.698 2.074H2.663L6.265 5h2.382l3.574 10.092H9.934l-.65-2.074Zm-.589-1.74-1.26-3.97-1.3 3.97h2.56Z"
    />
  </Svg>
);
export default SvgComponent;
